import { useMemo } from 'react'

import { useUser } from '@hooks/useUser'

import type { UsePermissionProps } from './types'


export const usePermission = (pageId: number): UsePermissionProps => {
  const { userPermissionsData, getPagePermissions } = useUser()
  const permission = useMemo(() => getPagePermissions(pageId), [pageId, userPermissionsData])

  return useMemo(() => {
    if (!permission) {
      return {
        canView: false,
        canEdit: false,
        canCreate: false,
        canDelete: false,
        canApprove: false,
        isReadOnly: true
      }
    }

    const hasFull = permission.totalPermission
    const canView = hasFull || permission.canView
    const canEdit = permission.canEdit
    const canCreate = hasFull || permission.canCreate
    const canDelete = hasFull || permission.canDelete
    const canApprove = hasFull || permission.canApprove
    const isReadOnly = canView && !canEdit

    return {
      canView,
      canEdit,
      canCreate,
      canDelete,
      canApprove,
      isReadOnly
    }
  }, [permission])
}
